import React, { Component } from "react";
class NotFound extends Component {
  state = {};
  render() {
    return <div>404 Page Not Found</div>;
  }
}

export default NotFound;
